import { getSupabasePublicEnv } from '@/utils/publicEnv'

export function isSupabaseRestRequest(url: string): boolean {
  try {
    const { url: supabaseUrl } = getSupabasePublicEnv()
    return url.startsWith(`${supabaseUrl}/rest`)
  } catch {
    return false
  }
}
